export default __webpack_public_path__ + "static/media/gallery (16).bd650336.png";